export default "__VITE_ASSET__DJSMLM7v__"